import PropTypes from 'prop-types';
import { PillOverlayPopover, Radio } from '@utilities';

import styles from './_index.module.scss';

const LogicOptions = ({ isCompleted, logicOptions, optionsLabel, setValue, value }) => {
  return (
    <PillOverlayPopover
      isCompleted={isCompleted}
      overlayClassName={styles['logic-options-overlay']}
      value={logicOptions.find((opt) => opt.value === value)?.text}
    >
      <div className={styles['logic-options-label']}>{optionsLabel}</div>
      <ul className={styles['logic-options-list']}>
        {logicOptions.map((option) => (
          <li key={option.value}>
            <Radio
              isChecked={value === option.value}
              label={option.text}
              onChange={() => setValue(option.value)}
              value={option.value}
            />
          </li>
        ))}
      </ul>
    </PillOverlayPopover>
  );
};

LogicOptions.propTypes = {
  isCompleted: PropTypes.bool,
  logicOptions: PropTypes.array.isRequired,
  optionsLabel: PropTypes.string,
  setValue: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default LogicOptions;
